<template>
    <div>
        <v-layout column wrap>
            <v-layout justify-space-between>
                <p class="px-0 black--text subheading font-weight-bold">
                    <span v-if="isSimple && !isDual">Win {{win}}, </span>
                    <span v-if="completed">Your Selection:</span>
                    <span v-else-if="!isTotal">Choose:</span>
                </p>
                <p class="px-0 black--text subheading font-weight-bold" v-if="!completed">
                    <countdown-timer ref="countDown" :date="date"/>
                </p>
            </v-layout>

            <div v-if="isLine" style="width: 100%">
                <v-item-group v-model="selectedTeam" active-class="accent round " style="width: 100%">
                    <v-layout justify-space-between align-center fill-height row pt-0>
                        <v-flex xs5 class="d-flex align-content-center">
                            <v-item :value="instaplay.contestant1.name" class="round border overflow-hidden">
                                <v-layout column align-center slot-scope="{ active, toggle }" dark
                                          @click="!completed? toggle(): ''">
                                    <v-responsive :aspect-ratio="1">
                                        <img :src="instaplay.contestant1.image" style="max-width: 100%">
                                    </v-responsive>
                                    <div class="font-weight-bold">{{instaplay.contestant1.name}}</div>
                                    <div>{{lineSCoins(instaplay.contestant1)}}</div>
                                </v-layout>
                            </v-item>
                        </v-flex>
                        <p class="pt-5 mt-5 font-weight-bold">vs.</p>
                        <v-flex xs5 class="d-flex align-content-center">
                            <v-item :value="instaplay.contestant2.name" class="round border overflow-hidden">
                                <v-layout column align-center slot-scope="{ active, toggle }" dark
                                          @click="!completed? toggle(): ''">
                                    <v-responsive :aspect-ratio="1">
                                        <img :src="instaplay.contestant2.image" style="max-width: 100%">
                                    </v-responsive>
                                    <div class="font-weight-bold">{{instaplay.contestant2.name}}</div>
                                    <div>{{lineSCoins(instaplay.contestant2)}}</div>
                                </v-layout>
                            </v-item>
                        </v-flex>
                    </v-layout>
                </v-item-group>
            </div>

            <v-layout v-if="isBracket" justify-center mt-4 mb-3>
                <bracket-item :model="bracketModel" :teams="contestants" :all-teams="contestants" root>
                    <div class="text-xs-center font-weight-bold py-4">{{ instaplay.bracket.winnerLabel }}</div>
                </bracket-item>
            </v-layout>

            <div v-else-if="isSimple || isPool" style="width: 100%">
                <v-item-group v-if="isDual" v-model="selectedTeam" active-class="accent round " style="width: 100%">
                    <v-layout justify-space-between align-center fill-height row pt-0>
                        <v-flex xs5 class="d-flex align-content-center">
                            <v-item :value="instaplay.contestant1.name" class="round border overflow-hidden">
                                <v-layout column align-center slot-scope="{ active, toggle }" dark
                                          @click="!completed? toggle(): ''">
                                    <v-responsive :aspect-ratio="1">
                                        <img :src="instaplay.contestant1.image" style="max-width: 100%">
                                    </v-responsive>
                                    <div class="font-weight-bold">{{instaplay.contestant1.name}}</div>
                                    <div>{{instaplay.contestant1.probability | percent}}</div>
                                </v-layout>
                            </v-item>
                        </v-flex>
                        <p class="pt-5 mt-5 font-weight-bold">vs.</p>
                        <v-flex xs5 class="d-flex align-content-center">
                            <v-item :value="instaplay.contestant2.name" class="round border overflow-hidden">
                                <v-layout column align-center slot-scope="{ active, toggle }" dark
                                          @click="!completed? toggle(): ''">
                                    <v-responsive :aspect-ratio="1">
                                        <img :src="instaplay.contestant2.image" style="max-width: 100%">
                                    </v-responsive>
                                    <div class="font-weight-bold">{{instaplay.contestant2.name}}</div>
                                    <div>{{instaplay.contestant2.probability | percent}}</div>
                                </v-layout>
                            </v-item>
                        </v-flex>
                    </v-layout>
                </v-item-group>
                <v-item-group v-else v-model="selectedTeam" active-class="accent round " style="width: 100%">
                    <v-layout justify-space-between align-center fill-height row pt-0 column>
                        <v-item v-for="n in instaplay.numContestants" :key="n" :value="instaplay['contestant'+n].name"
                                class="round border overflow-hidden mb-3" style="width: 100%">
                            <v-layout align-center slot-scope="{ active, toggle }" @click="!completed? toggle(): ''"
                                      class="text-xs-center">
                                <v-flex xs4>
                                    <div class="font-weight-bold">{{instaplay['contestant'+n].name}}</div>
                                </v-flex>
                                <v-flex xs4>
                                    <img v-if="instaplay['contestant'+n].image"
                                         :src="instaplay['contestant'+n].image"
                                         style="max-width: 100%; max-height: 60px">
                                    <v-avatar v-else class="text-capitalize white--text primary my-1">
                                        {{instaplay['contestant'+n].name[0]}}
                                    </v-avatar>
                                </v-flex>
                                <v-flex xs4>
                                    <div>{{instaplay['contestant'+n].probability | percent}}</div>
                                </v-flex>
                            </v-layout>
                        </v-item>

                    </v-layout>
                </v-item-group>
            </div>

            <div v-else-if="isSpread" style="width: 100%">
                <div class="black--text subheading font-weight-bold">
                    {{favored.name}} favored {{underdog.name}} by {{instaplay.spread.pointSpread}} points:
                </div>
                <v-layout align-center justify-space-between class="text-xs-center">
                    <v-flex xs3>
                        <v-layout column align-center>
                            <v-responsive :aspect-ratio="1">
                                <img :src="favored.image" :alt="favored.name" style="max-width: 90%">
                            </v-responsive>
                            <div class="font-weight-bold">{{favored.name}}</div>
                        </v-layout>
                    </v-flex>
                    <v-flex class="font-weight-bold">Beats</v-flex>
                    <v-flex xs3>
                        <v-layout column align-center>
                            <v-responsive :aspect-ratio="1">
                                <img :src="underdog.image" :alt="underdog.name" style="max-width: 90%">
                            </v-responsive>
                            <div class="font-weight-bold">{{underdog.name}}</div>
                        </v-layout>
                    </v-flex>
                    <v-flex class="font-weight-bold">by</v-flex>
                    <v-flex class="display-3 grey--text">{{instaplay.spread.pointSpread}}</v-flex>
                </v-layout>
                <v-item-group v-model="selectedTeam" active-class="accent round " style="width: 100%">
                    <v-layout justify-space-around align-center mt-3>
                        <v-flex xs5 class="d-flex align-content-center">
                            <v-item value="yes" class="round border overflow-hidden">
                                <v-layout column align-center slot-scope="{ active, toggle }"
                                          @click="!completed? toggle(): ''" pa-3
                                          class="headline">
                                    Yes
                                </v-layout>
                            </v-item>
                        </v-flex>
                        <v-flex xs5 class="d-flex align-content-center">
                            <v-item value="no" class="round border overflow-hidden">
                                <v-layout column align-center slot-scope="{ active, toggle }"
                                          @click="!completed? toggle(): ''" pa-3
                                          class="headline">
                                    No
                                </v-layout>
                            </v-item>
                        </v-flex>
                    </v-layout>
                </v-item-group>
            </div>

            <div v-else-if="isTotal" style="width: 100%">
                <div class="black--text subheading font-weight-bold text-xs-left" v-if="!completed">
                    Over or Under:
                </div>
                <v-layout align-center justify-space-between class="text-xs-center">
                    <v-flex xs3>
                        <v-layout column align-center>
                            <v-responsive :aspect-ratio="1">
                                <img :src="favored.image" :alt="favored.name" style="max-width: 90%">
                            </v-responsive>
                            <div class="font-weight-bold">{{favored.name}}</div>
                        </v-layout>
                    </v-flex>
                    <v-flex class="font-weight-bold display-1">+</v-flex>
                    <v-flex xs3>
                        <v-layout column align-center>
                            <v-responsive :aspect-ratio="1">
                                <img :src="underdog.image" :alt="underdog.name" style="max-width: 90%">
                            </v-responsive>
                            <div class="font-weight-bold">{{underdog.name}}</div>
                        </v-layout>
                    </v-flex>
                    <v-flex class="display-3 grey--text">: {{instaplay.total.totalpoints}}</v-flex>
                </v-layout>
                <v-item-group v-model="selectedTeam" active-class="accent round " style="width: 100%">
                    <v-layout justify-space-around align-center mt-3>
                        <v-flex xs5 class="d-flex align-content-center">
                            <v-item value="over" class="round border overflow-hidden">
                                <v-layout column align-center slot-scope="{ active, toggle }"
                                          @click="!completed? toggle(): ''" pa-3
                                          class="headline">
                                    <v-icon>expand_less</v-icon>
                                    OVER
                                </v-layout>
                            </v-item>
                        </v-flex>
                        <v-flex xs5 class="d-flex align-content-center">
                            <v-item value="under" class="round border overflow-hidden">
                                <v-layout column align-center slot-scope="{ active, toggle }"
                                          @click="!completed? toggle(): ''" pa-3
                                          class="headline">
                                    UNDER
                                    <v-icon>expand_more</v-icon>
                                </v-layout>
                            </v-item>
                        </v-flex>
                    </v-layout>
                </v-item-group>
            </div>

            <v-layout v-if="isSimple && isDual" justify-center mt-4 mb-3>
                <v-flex xs5>
                    <v-layout align-center column>
                        <div class="font-weight-bold">Win</div>
                        <p class="headline font-weight-bold">{{ win }}</p>
                        <img :src="require('../assets/CoinPile.png')" height="90">
                    </v-layout>
                </v-flex>
            </v-layout>

            <v-layout v-if="isPool && isDual || isBracket" justify-space-between mt-4 mb-3>
                <v-flex xs5>
                    <v-layout align-center column>
                        <div class="font-weight-bold">Risk</div>
                        <p>
              <span style="width: 45px; display: inline-block">
                <v-text-field
                        v-model.number="riskCoins"
                        :disabled="!selectedTeam && !isBracket"
                        type="number" :readonly="completed"
                        :min="instaplay[instaplay.InstaplayType].minCoinsToPlay"
                        :max="instaplay[instaplay.InstaplayType].maxCoinsToPlay"
                        :rules="[v=> v>=1 || '']"
                />
              </span>
                        </p>
                        <img :src="require('../assets/SingleCoin.png')" height="22">
                    </v-layout>
                </v-flex>
                <v-icon color="black" class="pb-5">arrow_forward</v-icon>
                <v-flex xs5>
                    <v-layout align-center column>
                        <div class="font-weight-bold">Win</div>
                        <p class="headline font-weight-bold">{{ win }}</p>
                        <img :src="require('../assets/CoinPile.png')" height="90">
                    </v-layout>
                </v-flex>
            </v-layout>

            <v-layout v-if="isTotal || isLine || isSpread" justify-space-between mt-4 mb-3>
                <v-flex xs5>
                    <v-layout align-center column>
                        <div class="font-weight-bold">Risk</div>
                        <div class="headline font-weight-bold">{{ risk }}</div>
                        <p>
                            <span class="headline font-weight-bold">(</span>
                            <span style="width: 45px; display: inline-block">
                <v-text-field v-model.number="riskCoins"
                              :disabled="!this.selectedTeam"
                              type="number" :readonly="completed" min="1"
                              :rules="[v=> v>=1 || '']"></v-text-field></span>
                            <span class="headline font-weight-bold"> &times; </span> <span class="subheading">{{perCoin}}</span><span
                                class="headline font-weight-bold"> )</span>
                        </p>
                        <img :src="require('../assets/SingleCoin.png')" height="22">
                    </v-layout>
                </v-flex>
                <v-icon color="black" class="pb-5">arrow_forward</v-icon>
                <v-flex xs5>
                    <v-layout align-center column>
                        <div class="font-weight-bold">Win</div>
                        <p class="headline font-weight-bold">{{ win }}</p>
                        <img :src="require('../assets/CoinPile.png')" height="90">
                    </v-layout>
                </v-flex>
            </v-layout>

        </v-layout>
        <div class="text-xs-left font-weight-bold">
      <span v-if="isPool && !isDual">
            Risk
              <span style="width: 45px; display: inline-block">
                <v-text-field v-model.number="riskCoins"
                              :disabled="!this.selectedTeam"
                              type="number" :readonly="completed"
                              class="py-0 my-0"
                              :min="this.instaplay.pool.minCoinsToPlay"
                              :max="this.instaplay.pool.maxCoinsToPlay"
                              :rules="[v=> v>=1 || '']"></v-text-field>
              </span>
             to win {{win}} SCoins
          </span>
        </div>
        <p class="error--text v-messages" v-if="!!inputError">{{inputError}}</p>
        <p class="font-weight-bold" v-if="completed && playInfo">
            <span v-if="playInfo.winner === 0 || playInfo.winner === '0' || playInfo.winner === 'tie'">Tied, no SCoins awarded.</span>
            <span v-else-if="playInfo.winner">Winner is {{instaplay['contestant' + playInfo.winner].name}}</span>
        </p>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                    round color="accent"
                    depressed
                    @click="play"
                    style="width: 50%"
                    :disabled="!valid"
                    :outline="!valid"
                    :loading="isPlayLoading"
                    v-if="!completed"
            >
            <span class="black--text">
            {{submitText}}
            </span>
            </v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex'

    import CountdownTimer from "@/components/CountdownTimer";
    import {win} from "@/services/instaplay";
    import BracketItem from "@/components/BracketItem";

    export default {
        name: "InstaplayPreview",
        components: {BracketItem, CountdownTimer},
        props: {
            instaplay: {
                type: Object,
            },
            active: {
                default: false,
                type: Boolean
            },
            completed: {
                default: false,
                type: Boolean
            },
            preview: {
                default: false,
                type: Boolean
            },
            selection: Object,
            playInfo: Object
        },
        data() {
            return {
                selectedTeam: '',
                riskCoins: '',
                bracketModel: {}
            }
        },
        computed: {
            ...mapGetters('instaplays', ['isPlayLoading', 'isPlaySuccess']),
            submitText() {
                return this.active ? 'change' : 'submit'
            },
            valid() {
                return ((!!this.selectedTeam || this.isBracket) && (this.riskCoins >= 1 || this.isSimple) && !this.inputError)
                    && (!this.isBracket || Object.values(this.bracketModel).every(x => x !== ""))
            },
            risk() {
                if (this.isPool || this.isBracket) return this.riskCoins
                return !this.selectedTeam ? '?' : this.perCoin * this.riskCoins
            },
            win() {
                return win({
                    isLine: this.isLine,
                    selectedTeam: this.selectedTeam,
                    favoredName: this.favored.name,
                    perCoin: this.perCoin,
                    riskCoins: this.riskCoins,
                    instaplay: this.instaplay,
                    isSimple: this.isSimple,
                    isPool: this.isPool,
                    isBracket: this.isBracket,
                    active: this.active,
                    completed: this.completed,
                    selection: this.selection,
                    risk: this.risk,
                    preview: this.preview
                })
            },
            contestants() {
                let arr = []
                let order = []
                if (this.instaplay.bracket)
                    order = this.instaplay.bracket.order
                else
                    for (let i = 1; i <= this.instaplay.numContestants; i++)
                        order.push[i]
                let index = 1
                for (let i of order) {
                    let obj = {...this.instaplay['contestant' + i], id: i, index}
                    arr.push(obj)
                    index++
                }
                return arr
            },
            perCoin() {
                if (this.isLine)
                    return !this.selectedTeam ? '?' : this.selectedTeam === this.favored.name ? this.instaplay.line.SCoinFavored : 10
                else if (this.isSimple)
                    return 0
                else if (this.isPool || this.isBracket)
                    return 0
                else
                    return this.instaplay[this.instaplay.InstaplayType].wagerSCoins
            },
            underdog() {
                if (!this.instaplay)
                    return ''
                return this.instaplay.contestant1.probability < this.instaplay.contestant2.probability ?
                    this.instaplay.contestant1 : this.instaplay.contestant2
            },
            favored() {
                if (!this.instaplay)
                    return ''
                return this.instaplay.contestant1.probability > this.instaplay.contestant2.probability ?
                    this.instaplay.contestant1 : this.instaplay.contestant2
            },
            date() {
                return {
                    year: this.instaplay.startYear,
                    month: this.instaplay.startMonth,
                    day: this.instaplay.startDay,
                    hour: this.instaplay.startHour,
                    minute: this.instaplay.startMinute
                }
            },
            inputError() {
                if (!this.isPool && !this.isBracket)
                    return ''
                let min = this.instaplay[this.instaplay.InstaplayType].minCoinsToPlay
                let max = this.instaplay[this.instaplay.InstaplayType].maxCoinsToPlay
                return this.riskCoins !== ''
                    ? (this.riskCoins < min || this.riskCoins > max)
                        ? 'Risk must be between ' + min + ' and ' + max : '' : ''
            },
            isLine() {
                return this.instaplay.InstaplayType === 'line'
            },
            isSimple() {
                return this.instaplay.InstaplayType === 'simple'
            },
            isSpread() {
                return this.instaplay.InstaplayType === 'spread'
            },
            isTotal() {
                return this.instaplay.InstaplayType === 'total'
            },
            isPool() {
                return this.instaplay.InstaplayType === 'pool'
            },
            isBracket() {
                return this.instaplay.InstaplayType === 'bracket'
            },
            isDual() {
                return this.instaplay.numContestants === 2
            }
        },
        methods: {
            ...mapActions('instaplays', ['playInstaplay', 'modifyPlay']),
            ...mapMutations('notification', ['showSnackbar']),
            play() {
                if (this.completed || this.preview) return
                if (!this.$store.getters['auth/isLoggedIn']) {
                    let query = this.getPlayPayload()
                    this.$router.replace({query: {...this.$route.query, play: JSON.stringify(query)}})
                    return this.$emit("loginReq")
                }
                if (!this.active)
                    this.playInstaplay(this.getPlayPayload())
                        .then(() => {
                            if (this.isPlaySuccess) {
                                this.$emit('close')
                                this.showSnackbar({text: 'Instaplay moved to active list.', type: 'success'})
                            }
                        })
                else
                    this.modifyPlay(this.getPlayPayload())
                        .then(() => {
                            if (this.isPlaySuccess) {
                                this.$emit('close')
                                this.showSnackbar({text: 'Play modified.', type: 'success'})
                            }
                        })
            },
            getPlayPayload() {
                let bracket = Object.assign({}, this.bracketModel)
                switch (this.instaplay.InstaplayType) {
                    case "simple":
                        return {
                            InstaplayId: this.instaplay.InstaplayId,
                            InstaplayType: this.instaplay.InstaplayType,
                            selectedContestantID: this.findContestandID(this.selectedTeam, this.instaplay),
                            selectedContestantName: this.selectedTeam,
                        }
                    case "total":
                        return {
                            InstaplayId: this.instaplay.InstaplayId,
                            InstaplayType: this.instaplay.InstaplayType,
                            riskedSCoins: this.risk,
                            winSCoins: this.win,
                            overORunder: this.selectedTeam,
                        }
                    case "spread":
                        return {
                            InstaplayId: this.instaplay.InstaplayId,
                            InstaplayType: this.instaplay.InstaplayType,
                            riskedSCoins: this.risk,
                            winSCoins: this.win,
                            yesORno: this.selectedTeam,
                        }
                    case "line":
                    case "pool":
                        return {
                            InstaplayId: this.instaplay.InstaplayId,
                            InstaplayType: this.instaplay.InstaplayType,
                            selectedContestantID: this.findContestandID(this.selectedTeam, this.instaplay),
                            selectedContestantName: this.selectedTeam,
                            riskedSCoins: this.risk,
                            winSCoins: this.win
                        }
                    case "bracket":
                        for (let i = 1; i <= this.instaplay.numContestants; i++)
                            delete bracket[i]
                        return {
                            InstaplayId: this.instaplay.InstaplayId,
                            InstaplayType: this.instaplay.InstaplayType,
                            riskedSCoins: this.risk,
                            winSCoins: this.win,
                            bracket
                        }
                }
            },
            findContestandID(name, inst) {
                for (let i = 1; i <= inst.numContestants; i++)
                    if (name === inst['contestant' + i].name)
                        return i
            },
            startTimer() {
                this.$refs.countDown.start()
            },
            stopTimer() {
                this.$refs.countDown.stop()
            },
            lineSCoins(contestant) {
                if (this.isLine) {
                    return contestant === this.favored ? -this.instaplay.line.SCoinFavored : this.instaplay.line.SCoinUnderdog
                }
                return 0
            },
            clearSelection() {
                this.selectedTeam = ''
            },
            setSelection(info) {
                if (!info.selected || info.risked === null || this.risked === '') return
                this.selectedTeam = info.selected
                this.riskCoins = this.isPool || this.isBracket ? info.risked : info.risked / this.perCoin
                if (this.isBracket) {
                    Object.assign(this.bracketModel, info.selected)
                }
            }
        },
        watch: {
            selectedTeam: function (val) {
                if (this.completed) return
                if (val) {
                    if (this.riskCoins === '')
                        this.riskCoins = this.isPool || this.isBracket ? this.instaplay[this.instaplay.InstaplayType].minCoinsToPlay : 1
                } else {
                    this.riskCoins = ''
                }
                this.$emit('input', {selected: val, risked: this.risk})
            },
            riskCoins: function () {
                this.$emit('input', {selected: this.selectedTeam, risked: this.risk})
            }
        },
        mounted() {
            if (!this.completed)
                this.startTimer()
            if (this.selection)
                this.setSelection(this.selection)
        },
        beforeDestroy() {
            if (!this.completed)
                this.stopTimer()
        },
        filters: {
            percent: function (value) {
                let x = 100 * value
                if (x % 1 === 0)
                    return x + '%'
                else if (x % 1 < 0.1)
                    return x.toFixed(0) + '%'
                return x.toFixed(1) + '%'
            }
        }
    }
</script>

<style scoped>
    .round {
        border-radius: 1.5rem;
    }

    .border {
        border: solid 1px grey !important;
    }
</style>
